import Request from 'admin/lib/adminRequest';

export default {
    list: async ({ query, id: mid, pagination }) => {
        const { page, pageSize: limit } = pagination;
        try {
            const [groupsRes, selectedRes] = await Promise.all([
                Request.postJSON('admin/project/listProjectGroups', {
                    query,
                    limit,
                    page
                }),
                Request.postJSON('admin/project/listProjectGroups', {
                    mid: mid === undefined ? [] : mid
                })
            ]);

            if (groupsRes.error || selectedRes.error) {
                throw new Error(groupsRes.msg || selectedRes.msg);
            }

            const projectGroups = { data: groupsRes.data, count: groupsRes.count };
            const selected = { data: selectedRes.data };

            selected.data.forEach(itemSelected => {
                const item = projectGroups.data.find(
                    itemProjectGroup =>
                        itemProjectGroup.mid === itemSelected.mid
                );
                if (!item) {
                    projectGroups.data.push({
                        ...itemSelected,
                        missingSelected: true
                    });
                }
            });

            return projectGroups;
        } catch (err) {
            console.error(err);
        }
    }
};
